AgrimarketControllers.controller('portfolioController', [
    '$scope', '$rootScope', '$filter', '$sce', 'portfolioService', '$routeParams', 'contractsColumns', 'ordersColumns', 'wsdApiService',
    'typeContractsService', 'productsService', 'ceremisApiService', 'coverService', 'enumFactory', 'athenaOrdersService', 'dateService',
    'configurationFactory',
    function ($scope, $rootScope, $filter, $sce, portfolioService, $routeParams, contractsColumns, ordersColumns, wsdApiService,
        typeContractsService, productsService, ceremisApiService, coverService, enumFactory, athenaOrdersService, dateService, configurationFactory) {

        $scope.markets = [];
        $scope.expiries = [];
        $scope.enumOrderTypes = enumFactory.AthenaOrderTypes;
        $scope.enumOrderStates = enumFactory.AthenaOrderStates;
        $scope.viewMode = $routeParams.typeView;
        $scope.IsUneal = $rootScope.paramNameCoop === enumFactory.Coops.Uneal;
        $scope.enumStrategies = enumFactory.Strategies;
        $scope.init = function () {

            wsdApiService.GetMarketsWSDToEuronext(function (data, status) {
                $scope.markets = data;
            });

            $scope.filters = {
                startDate: $filter('date')(new Date(new Date().setDate(new Date().getDate() - 15)), 'dd/MM/yyyy'),
                endDate: "",
                reverse: false,
                page: 1,
                itemsPerPage: 10
            };
            $scope.$watch("filters", function (newValue, oldValue) {
                if (oldValue.idMarket !== newValue.idMarket) {
                    $scope.filters.idExpiry = undefined;
                    if (newValue.idMarket !== undefined) {
                        wsdApiService.GetExpiriesWSDByIdMarket(newValue.idMarket, function (data, status) {
                            $scope.expiries = data.Expiries;
                        });
                    }
                }
                if ($scope.HandleFiltersChange !== undefined)
                    $scope.HandleFiltersChange(newValue, oldValue);
                if ((newValue && oldValue !== newValue) || (!newValue && oldValue)) {
                    $scope.fetch();
                }
            }, true);

            switch ($scope.viewMode) {
                case "contracts":
                    $scope.contractsKeys = contractsColumns.data.DataVisible.split(',');
                    $scope.contractsColumns = contractsColumns.data.ColumnName.split(',');
                    $scope.varieties = [{ Label: 'Aucune', IdVariety: undefined }];

                    $scope.HandleFiltersChange = function (newValue, oldValue) {
                        if (oldValue.idProduct !== newValue.idProduct) {
                            $scope.filters.idVariety = undefined;
                            if (newValue.idProduct !== undefined) {
                                var selectedProduct = $rootScope.products.find(function (p) {
                                    return p.IdProduct === newValue.idProduct;
                                });
                                $scope.varieties = $scope.varities = [{ Label: 'Aucune', IdVariety: undefined }];
                                selectedProduct.Varieties.forEach(function (x) { $scope.varieties.push(x); });
                            }
                            else {
                                $scope.varieties = [{ Label: 'Aucune', IdVariety: undefined }];
                            }
                        }
                    };

                    $scope.fetch = $scope.getContracts;

                    typeContractsService.GetTypeContracts(function (data) {
                        $scope.contractTypes = [
                            { Label: 'Aucun', IdTypeContract: undefined }
                        ];
                        data.forEach(function (x) { $scope.contractTypes.push(x); });
                    });

                    productsService.GetAllProducts(function (data) {
                        $scope.products = [
                            { Label: 'Aucun', IdProduct: undefined }
                        ];
                        data.forEach(function (x) { $scope.products.push(x); });
                    });

                    portfolioService.GetContractStatuses(function (data) {
                        $scope.contractStatuses = [
                            { Label: 'Aucun', IdStatus: undefined }
                        ];
                        data.forEach(function (x) { $scope.contractStatuses.push(x); });
                    });

                    $scope.showContractDetails = function (contract, show) {
                        $scope.contractDetailsTitle = "Ordres couvrant le contrat " + contract.IdContract;
                        $scope.orders = contract.Orders;
                        show();
                    };

                    break;
                case "orders":
                    // Orders
                    $scope.ordersKeys = ordersColumns.data.DataVisible.split(',');
                    $scope.ordersColumns = ordersColumns.data.ColumnName.split(',');

                    $scope.orderTypes = [
                        enumFactory.AthenaOrderTypes.Market,
                        enumFactory.AthenaOrderTypes.Limit
                    ];

                    portfolioService.GetOrderStatuses(function (data, status) {
                        $scope.orderStatuses = [{ Label: 'Aucun', IdStatus: undefined }];
                        data.forEach(function (x) { $scope.orderStatuses.push(x); });
                    });

                    if ($rootScope.parambActiveLinkWithAgrimaster) {
                        portfolioService.GetFiltersAgrimaster(function (data, status) {
                            $scope.cropsFilter = data.Crops;
                            $scope.productsFilter = data.Products;
                            $scope.strategiesFilter = data.Strategies;
                        });
                    }

                    $scope.directions = [
                        { label: 'Vente', id: 'v' },
                        { label: 'Achat', id: 'a' }
                    ];

                    $scope.origins = [
                        { label: 'Aucun', id: undefined },
                        { label: 'Couverture de contrat', id: 'Couverture de contrat' },
                        { label: 'Ordre seul', id: 'Ordre seul' }
                    ];

                    $scope.fetch = $scope.getOrders;

                    $scope.showOrderDetails = function (order, show) {
                        $scope.orderDetailsTitle = "Contrats couverts par l'ordre " + order.IdOrder;
                        $scope.contracts = order.Contracts;
                        $scope.selectedOrder = order;
                        show();
                    };

                    break;
            }
            $scope.fetch();
        };

        $scope.GetData = function (page) {
            $scope.filters.page = page;
        };

        $scope.Sort = function (sortKey, reverse) {
            $scope.filters.sortKey = sortKey;
            $scope.filters.reverse = reverse;
        };
        $scope.getContracts = function () {
            var params = {};
            Object.assign(params, $scope.filters);
            params.startDate = $scope.filters.startDate ? toDate($scope.filters.startDate) : null;
            params.endDate = $scope.filters.endDate ? toDate($scope.filters.endDate) : null;
            portfolioService.GetContracts(params, function (data, status) {
                $scope.contracts = angular.copy(data.Page);
                $scope.contractsTotal = data.Total;
            });
        };

        $scope.getOrders = function () {
            var params = {};
            Object.assign(params, $scope.filters);
            params.startDate = dateService.isValidDate($scope.filters.startDate) ? toDate($scope.filters.startDate) : null;
            params.endDate = dateService.isValidDate($scope.filters.endDate) ? toDate($scope.filters.endDate) : null;
            params.fixedDate = dateService.isValidDate($scope.filters.fixedDate) ? toDate($scope.filters.fixedDate) : null;
            portfolioService.GetOrders(params, function (data, status) {
                $scope.orders = angular.copy(data.Page);
                $scope.ordersTotal = data.Total;
            });
        };

        $scope.ToggleConfirmOrderPopup = function () {
            $scope.confirmOrderPopup = !$scope.confirmOrderPopup;
        };

        $scope.OpenPopUpOrder = function (openPopup) {
            $scope.openPopupOrder = openPopup;
            $scope.orderPopUp = {};
            $scope.confirmOrderPopup = false;
            $scope.popupOrderErrorMessage = "";
            $scope.modalTitle = $rootScope.editableObjectsFactory.EditableObjects.ModalTitleAddOrder.Content;
            $scope.marketsPopUp = $scope.markets;

            if ($rootScope.parambActiveLinkWithAgrimaster) {
                $scope.marketsPopUp = [];
                $scope.orderTypes = [];
                $scope.expiriesPopUp = [];
                portfolioService.GetInfosForOrderAgrimaster(function (data, status) {
                    $scope.cropsPopUpOrder = data.Crops;
                    $scope.productsPopUpOrder = data.Products;
                    $scope.strategiesPopUpOrder = data.Strategies;
                });
            }
            else if ($scope.IsUneal)
                filterMarketsWsdByOffersCeremis();

            if (!$rootScope.parambActiveLinkWithAgrimaster) getAccounts();

            openPopup();
        };

        $scope.openPopUpOrderRestartOrEdit = function (order, openPopup, isEdit) {
            if(isEdit)
                $scope.modalTitle = $rootScope.editableObjectsFactory.EditableObjects.ModalTitleEditOrder.Content + " " + order.IdOrder;
            else
                $scope.modalTitle = $rootScope.editableObjectsFactory.EditableObjects.ModalTitleRestartOrder.Content + " " + order.IdOrder;

            $scope.openPopupOrder = openPopup;
            $scope.orderPopUp = {};
            $scope.confirmOrderPopup = false;
            $scope.loadPopUpOrder(order);
            $scope.popupOrderErrorMessage = "";
            $scope.marketsPopUp = $scope.markets;
            $scope.orderPopUp.IdOfferBuiltPrice = order.IdOfferBuiltPrice;

            if ($rootScope.parambActiveLinkWithAgrimaster) {
                $scope.marketsPopUp = [];
                $scope.orderTypes = [];
                portfolioService.GetInfosForOrderAgrimaster(function (data, status) {
                    $scope.cropsPopUpOrder = data.Crops;
                    $scope.productsPopUpOrder = data.Products;
                    $scope.strategiesPopUpOrder = data.Strategies;
                });
            }
            else if ($scope.IsUneal)
                filterMarketsWsdByOffersCeremis();

            if (!$rootScope.parambActiveLinkWithAgrimaster) getAccounts();

            openPopup();
        };

        $scope.loadPopUpOrder = function (order) {
            $scope.orderPopUp.IdOrder = order.IdOrder;
            $scope.orderPopUp.IdExt = order.IdExt;
            $scope.orderPopUp.IdMarketWsd = order.IdMarket;
            $scope.orderPopUp.IdExpiryWsd = order.IdExpiry;
            $scope.orderPopUp.IdAccount = order.IdAccount;
            $scope.orderPopUp.IdOrderType = order.OrderTypeId;
            $scope.orderPopUp.Price = order.TargetPrice;
            $scope.orderPopUp.EndDate = $filter('date')(order.ExpireDate, 'dd/MM/yyyy');
            $scope.orderPopUp.Direction = order.DirectionId;
            $scope.orderPopUp.Qty = order.lotNumber;

            if ($rootScope.parambActiveLinkWithAgrimaster) {
                $scope.orderPopUp.IdCrop = order.IdCrop;
                $scope.orderPopUp.IdProduct = order.IdProduct;
                $scope.orderPopUp.IdStrategyAgrimaster = order.IdStrategy;
                $scope.GetMarketsExpiriesForPopUp($scope.orderPopUp);
            }
            $scope.GetExpiriesForPopUp(order.IdMarket);
        };

        $scope.GetMarketsExpiriesForPopUp = function (order) {
            if (order.IdCrop && order.IdProduct && order.IdStrategyAgrimaster) {
                portfolioService.GetMarketsExpiriesAgrimaster(order.IdCrop, order.IdProduct, order.IdStrategyAgrimaster, function (data, status) {
                    if (status !== null) {
                        if (status == 400)
                            $scope.popupOrderErrorMessage = $sce.trustAsHtml(data[0].errors[0].Message);
                    } else {

                        $scope.lstOffersAgrimaster = data;
                        $scope.lstmarketTmp = [];
                        $.each($scope.markets, function (index, item) {
                            if ($scope.lstOffersAgrimaster.indexOf($filter('filter')($scope.lstOffersAgrimaster, { "IdMarketWSD": Number(item.IdMarket) }, true)[0]) !== -1) {
                                $scope.lstmarketTmp.push(item);
                            }
                        });
                        $scope.marketsPopUp = $scope.lstmarketTmp;
                    }
                });
            }
            else {
                $scope.marketsPopUp = [];
                $scope.orderTypes = [];
                $scope.expiriesPopUp = [];
            }
        };

        $scope.GetOrderTypeForPopUp = function (idExpiryWsd) {
            if ($rootScope.parambActiveLinkWithAgrimaster) {
                if (idExpiryWsd) {
                    var offer = $filter('filter')($scope.lstOffersAgrimaster, { "IdExpiryWSD": Number(idExpiryWsd) }, true)[0];
                    if (offer != null && offer.IdTypeOrder == null) {
                        $scope.orderTypes = [
                            enumFactory.AthenaOrderTypes.Market,
                            enumFactory.AthenaOrderTypes.Limit
                        ];
                    }
                    else if (offer != null && offer.IdTypeOrder == enumFactory.AthenaOrderTypes.Market.Id) {
                        $scope.orderTypes = [enumFactory.AthenaOrderTypes.Market];
                    }
                    else if (offer != null && offer.IdTypeOrder == enumFactory.AthenaOrderTypes.Limit.Id) {
                        $scope.orderTypes = [enumFactory.AthenaOrderTypes.Limit];
                    }
                }
                else {
                    $scope.orderTypes = [];
                }
            }
        };

        $scope.GetExpiriesForPopUp = function (idMarket) {
            if (idMarket) {
                wsdApiService.GetExpiriesWSDByIdMarket(idMarket, function (data, status) {
                    if (status !== null) {
                        if (status == 400)
                            $scope.popupOrderErrorMessage = $sce.trustAsHtml(data[0].errors[0].Message);
                    } else {
                        $scope.expiriesPopUp = data.Expiries;

                        if ($rootScope.parambActiveLinkWithAgrimaster) {
                            $scope.lstExpiryTmp = [];
                            $scope.orderTypes = [];
                            $.each($scope.expiriesPopUp, function (index, item) {
                                if ($scope.lstOffersAgrimaster.indexOf($filter('filter')($scope.lstOffersAgrimaster, { "IdExpiryWSD": Number(item.IdExpiry) }, true)[0]) !== -1) {
                                    $scope.lstExpiryTmp.push(item);
                                }
                            });
                            $scope.expiriesPopUp = $scope.lstExpiryTmp;
                            if ($scope.orderPopUp.IdExpiryWsd)
                                $scope.GetOrderTypeForPopUp($scope.orderPopUp.IdExpiryWsd);
                        }
                        else if ($scope.IsUneal) {
                            $scope.lstExpiryTmp = [];
                            $.each($scope.expiriesPopUp, function (index, item) {
                                if ($scope.lstOffersCeremis.indexOf($filter('filter')($scope.lstOffersCeremis, { "IdExpiryWSD": Number(item.IdExpiry) }, true)[0]) !== -1) {
                                    $scope.lstExpiryTmp.push(item);
                                }
                            });
                            $scope.expiriesPopUp = $scope.lstExpiryTmp;


                        }
                    }
                });
            }
            else {
                $scope.expiriesPopUp = [];
                $scope.orderTypes = [];
            }
        };

        $scope.SavePopupOrder = function () {
            $scope.orderPopUp.EndDate = toDate($scope.orderPopUp.EndDate);
            athenaOrdersService.PostAthenaOrderVm($scope.orderPopUp, function (data, status) {
                if (status !== null) {
                    if (status == 400) {
                        $scope.popupOrderErrorMessage = $sce.trustAsHtml(data[0].errors[0].Message);
                        if($scope.confirmOrderPopup) $scope.ToggleConfirmOrderPopup();
                        $scope.openPopupOrder();
                    }
                }
                else
                    $scope.init();
            });
        };

        function filterMarketsWsdByOffersCeremis() {
            ceremisApiService.GetOffersCeremis("", function (data, status) {
                if (status !== null) {
                    if (status == 400)
                        $scope.popupOrderErrorMessage = $sce.trustAsHtml(data[0].errors[0].Message);
                } else {
                    $scope.lstOffersCeremis = data;
                    $scope.lstmarketTmp = [];
                    $.each($scope.marketsPopUp, function (index, item) {
                        if ($scope.lstOffersCeremis.indexOf($filter('filter')($scope.lstOffersCeremis, { "IdMarketWSD": Number(item.IdMarket) }, true)[0]) !== -1) {
                            $scope.lstmarketTmp.push(item);
                        }
                    });
                    $scope.marketsPopUp = $scope.lstmarketTmp;
                }
            });
        }

        function getAccounts() {
            coverService.GetAllAccounts(function (data, status) {
                if (status !== null) {
                    if (status == 400)
                        $scope.popupOrderErrorMessage = $sce.trustAsHtml(data[0].errors[0].Message);
                } else
                    $scope.lstAccounts = data;
            });
        }

        $scope.$watch("orderPopUp.Qty", function (newValue, oldValue) {
            if (newValue && !isNaN(newValue))
                $scope.textConversionTon = $rootScope.editableObjectsFactory.EditableObjects.Admin_Routing_Orders_TextConversionTon.Content.replace("[qty]", newValue * 50);
            else
                $scope.textConversionTon = "";
        }, true);

        function toDate(date) {
            if (!date || date.trim() === "") return undefined;
            var pattern = /(\d{2})\/(\d{2})\/(\d{4})/;
            var dt = new Date(date.replace(pattern, '$3-$2-$1'));
            var currentDate = new Date(dt.toString());
            return moment(currentDate).format('YYYY/MM/DD');
        }

        $scope.ExportOrders = function () {
            var downloadPath = configurationFactory.Url['Api'] + 'Portfolio/GetOrdersXls/' +
                '?idMarket=' + $scope.filters.idMarket +
                '&idExpiry=' + $scope.filters.idExpiry +
                '&idStatus=' + $scope.filters.idStatus +
                '&direction=' + ($scope.filters.direction ? $scope.filters.direction : '') +
                '&origin=' + ($scope.filters.origin ? $scope.filters.origin : '') +
                '&startDate=' + (dateService.isValidDate($scope.filters.startDate) ? toDate($scope.filters.startDate) : '') +
                '&endDate=' + (dateService.isValidDate($scope.filters.endDate) ? toDate($scope.filters.endDate) : '') +
                '&idLanguage=' + $rootScope.language.IdLanguage +
                '&idCrop=' + $scope.filters.idCrop +
                '&idProduct=' + $scope.filters.idProduct +
                '&idStrategy=' + $scope.filters.idStrategy +
                '&limitPriceMin=' + ($scope.filters.limitPriceMin) +
                '&limitPriceMax=' + ($scope.filters.limitPriceMax) +
                '&priceMin=' + ($scope.filters.priceMin) +
                '&priceMax=' + ($scope.filters.priceMax) +
                '&fixedDate=' + (dateService.isValidDate($scope.filters.fixedDate) ? toDate($scope.filters.fixedDate) : '');
            window.open(downloadPath, '_blank', '');
        };

        $scope.init();

        $rootScope.onRefresh = function () {
            $scope.init();
        };

        $scope.CancelOrderPopUp = function (idOrder, showPopUpCancelOrder) {
            $scope.PopupConfirmationCancelMessage = $rootScope.editableObjectsFactory.EditableObjects.Admin_Routing_Orders_ModalConfirmationCancel.Content.replace("{{idOrder}}", idOrder);
            $scope.PopupConfirmationCancelTitle = $rootScope.editableObjectsFactory.EditableObjects.Admin_Routing_Orders_ModalTitleCancelOrder.Content;
            showPopUpCancelOrder(idOrder);
        };

        $scope.CancelOrder = function (idOrder) {
            athenaOrdersService.CancelAthenaOrder(idOrder, function (data, status) {
                if (status !== null) {
                    if (status === 400)
                        $scope.errorMessage = $sce.trustAsHtml(data[0].errors[0].Message);
                } else 
                    $scope.init();
            });
        };
    }]);